export default "__VITE_ASSET__Bnk6vpF7__"